import { Theme } from '@yandex-int/k-common';
import { useQuery } from 'react-query';
import { getThemesFlat } from '@yandex-int/k-common/client/api';

export interface RootThemesRequest {
    /**
     * Слаг предмета
     */
    subjectSlug: string;
    /**
     * Возвращать ли неопубликованные темы
     */
    showUnpublished?: boolean;
    /**
     * ID корневой темы для получения вложенных тем
     */
    rootId?: number;
    /**
     * Глубина получения тем
     */
    depth?: number;
}

export function useRootThemes(queryParams: RootThemesRequest, queryConfig = {}) {
    const requestParams = {
        depth: 0,
        ...queryParams,
    };

    return useQuery<Theme[]>(['themes-root'], () => getThemesFlat(requestParams), {
        ...queryConfig,
    });
}
